import { projectManagementApi } from '@/includes/projectManagementApi';

const pmCommitmentService = {
  async listCommitments(projectId, { status } = {}) {
    const params = status ? { params: { status } } : undefined;
    const response = await projectManagementApi.get(
      `/projects/${projectId}/commitments`,
      params,
    );
    return response.data;
  },

  async getCommitment(projectId, id) {
    const response = await projectManagementApi.get(`/projects/${projectId}/commitments/${id}`);
    return response.data;
  },

  async createCommitment(projectId, payload) {
    const response = await projectManagementApi.post(
      `/projects/${projectId}/commitments`,
      payload,
    );
    return response.data;
  },

  async updateCommitment(projectId, id, payload) {
    const response = await projectManagementApi.patch(
      `/projects/${projectId}/commitments/${id}`,
      payload,
    );
    return response.data;
  },

  async deleteCommitment(projectId, id) {
    const response = await projectManagementApi.delete(
      `/projects/${projectId}/commitments/${id}`,
    );
    return response.data;
  },

  async updateStatus(projectId, id, status, { completionComment } = {}) {
    const payload = { status };
    if (completionComment !== undefined) {
      payload.completionComment = completionComment;
    }
    const response = await projectManagementApi.patch(
      `/projects/${projectId}/commitments/${id}/status`,
      payload,
    );
    return response.data;
  },

  async recordCause(projectId, id, payload) {
    const response = await projectManagementApi.post(
      `/projects/${projectId}/commitments/${id}/cause`,
      payload,
    );
    return response.data;
  },
};

export default pmCommitmentService;
